import { ITableCell, ITableItemsData } from './types'
import { CellLocation, CellTemplates } from '@silevis/reactgrid'
import { CustomCellIconTemplate } from './Table/Cells/CustomCellIconTemplate'
import { CustomCellTextTemplate } from './Table/Cells/CustomCellTextTemplate'
import { CustomCellNumberTemplate } from './Table/Cells/CustomCellNumberTemplate'
import { CustomCellSelectTemplate } from './Table/Cells/CustomCellSelectTemplate'
import { CustomCellDatepickerTemplate } from './Table/Cells/CustomCellDatepickerTemplate'
import { CustomHeaderCellTemplate } from './Table/Cells/CustomHeaderCellTemplate'

export const customCellTemplates: CellTemplates = {
  icon: new CustomCellIconTemplate(),
  text: new CustomCellTextTemplate(),
  date: new CustomCellDatepickerTemplate(),
  number: new CustomCellNumberTemplate(),
  dropdown: new CustomCellSelectTemplate(),
  header: new CustomHeaderCellTemplate()
}

export const defaultTableCells: ITableCell[] = [
  { cellType: 'icon', columnId: 'icon', width: 40 },
  {
    cellType: 'dropdown',
    headerText: 'Contract Category',
    columnId: 'contract_category',
    width: 297,
    tooltipText:
      'Grouping of similar products or services that share common characteristics or uses',
    required: true
  },
  {
    cellType: 'dropdown',
    headerText: 'Led by',
    columnId: 'led_by',
    width: 297,
    tooltipText:
      'The organization who is initiating and responsible for the contracting efforts with the vendor throughout the life cycle of the agreements',
    required: true
  },
  {
    cellType: 'text',
    headerText: 'Category status',
    columnId: 'contract_category_status',
    width: 297,
    nonEditable: true,
    placeholder: '',
    tooltipText:
      'Classification that groups vendor contracts with similar goods or services'
  },
  {
    cellType: 'text',
    headerText: 'Contract responsible',
    columnId: 'contract_responsible',
    width: 297,
    nonEditable: true,
    placeholder: '',
    tooltipText:
      'Sourcing team member who is the point person to manage the category and its associated contracts'
  },
  {
    cellType: 'dropdown',
    headerText: 'Vendor',
    columnId: 'vendor',
    width: 297,
    tooltipText:
      'Supplier or Manufacturer who is awarded an agreement for a specific category',
    required: true
  },
  {
    cellType: 'dropdown',
    headerText: 'Vendor Contract Steward',
    columnId: 'vendor_contract_steward',
    width: 297,
    tooltipText:
      "Vendor's sourcing team member who is the point person to manage the contract for a specific category"
  },
  {
    cellType: 'date',
    headerText: 'Start Date',
    columnId: 'start_date',
    width: 144,
    placeholder: 'MM/DD/YYYY',
    tooltipText: 'Start date of the master agreement with the Vendor',
    required: true
  },
  {
    cellType: 'date',
    headerText: 'Finish Date',
    columnId: 'finish_date',
    width: 144,
    placeholder: 'MM/DD/YYYY',
    tooltipText: 'End date of the master agreement with the Vendor',
    required: true
  },
  {
    cellType: 'dropdown',
    headerText: 'Vendor fee type',
    columnId: 'vendor_fee_type',
    width: 297,
    tooltipText:
      'Select one of the Vendor fee options: Administration Fee, MarketplaceAR, No Fee'
  },
  {
    cellType: 'number',
    headerText: 'Admin Fee, %',
    columnId: 'admin_fee',
    width: 144,
    placeholder: '0',
    tooltipText:
      "If 'Admin Fee' is selected as the vendor fee type, enter the Admin Fee percentage"
  },
  {
    cellType: 'dropdown',
    headerText: 'Rebate type',
    columnId: 'rebate_type',
    width: 297,
    tooltipText: 'Rebate type applicable to the contract'
  },
  {
    cellType: 'number',
    headerText: 'Baseline spend, $',
    columnId: 'baseline_spend',
    width: 144,
    placeholder: '0',
    tooltipText:
      "If 'Growth' rebate is selected as the Rebate type, enter the baseline spend"
  },
  {
    cellType: 'number',
    headerText: 'Rebate amount, %',
    columnId: 'rebate_amount',
    width: 144,
    placeholder: '0',
    tooltipText:
      'Percentage applied to the AP invoice data to calculate rebate dollar amount'
  },
  {
    cellType: 'number',
    headerText: 'Threshold, %',
    columnId: 'threshold',
    width: 144,
    placeholder: '0',
    tooltipText:
      "If 'Marketshare' rebate is selected as the rebate type, enter the Marketshare target percentage for this vendor"
  },
  { cellType: 'icon', columnId: 'deleteIcon', width: 40 }
]

export const defaultHeaderRowId = 'header'

export const defaultFocusPosition: CellLocation = {
  columnId: defaultTableCells[0].columnId,
  rowId: defaultHeaderRowId
}

export const defaultRowData: ITableItemsData = {
  start_date: null,
  finish_date: null,
  admin_fee: null,
  vendor: '',
  contract_category: '',
  vendor_contract_steward: '',
  contract_responsible: '',
  vendor_fee_type: undefined,
  rebate_type: 'no_rebate',
  baseline_spend: null,
  rebate_amount: null,
  threshold: null,
  led_by: null,
  contract_category_status: null
}
